import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Modal } from 'antd-mobile';
import { list as getConferences } from '@/services/saas/conference';
import { dropDown } from '@/services/saas/dict';
import ManageBar from '@/components/manageBar';
import OrgPicker from '@/components/orgPicker';
import TimeTool from '@/components/manageTimeTool';
import EmptyContainer from '@/components/emptyContainer';
import moment from 'moment';
import './index.scss';
import { preRouteUrl } from '../../../sysConfig';
import { logout } from '@/utils';
import { MessageWarning } from '../common';

const TimeTable = (props) => {

  const history = useHistory();

  const DefaultParam = {
    sceneCode:'1,2',
    current: 1, 
    size: -1,
    orderName: 'SCHEDULED_START_TIME',
    orderDesc: 'no',
  }

  const [ visible, setVisible ] = useState(false);

  const [ businessType, setBusinessType ] = useState(null);

  const [ data, setData ] = useState({
    list: [],
    pagination: false,
  });

  const [ param, setParam ] = useState({
    time: moment(),
    memberId: undefined
  });

  const handleSearch = async () => {
    const { time, ...payload } = param;
    const paramObj = {
      ...payload,
    };
    if (time){
      paramObj.scheduledStartTimeBeginDate = time.format('YYYY-MM-DD');
      paramObj.scheduledStartTimeEndDate = time.format('YYYY-MM-DD');
    }

    const resp = await getConferences({ ...DefaultParam, ...paramObj });
    if (resp && resp.success) {
      setData({
        list: resp.data.records,
        pagination: false,
      });
    }
  }

  const pickerChange = (memberId) => {
    setParam({
      ...param,
      memberId
    });
  }

  const timeChange = (time) => {
    setParam({
      ...param,
      time
    });
  }

  const getBusinessType = async () => {
    const resp = await dropDown({ code: 'conference_business_type' });
    if (resp && resp.success) {
      setBusinessType(resp.data);
    }
  }

  const getDefault = async () => {
    if (!businessType) {
      await getBusinessType();
    }
    handleSearch();
  }

  const timeFormat = (dateStr) => {
    return moment(new Date(dateStr.replace(/-/g,'/')))
  }

  const handleClick = (item) => {
    let lessonType = undefined;
    switch (item.sceneCode) {
      case '1':
        lessonType = 'interact';
        break;
      case '2':
        lessonType = 'excellence';
        break;
      default:
        lessonType = undefined;
        break;
    }
    if (!lessonType) {
      MessageWarning("未知类型");
      return ;
    }
    history.push(`${preRouteUrl}/manage/${lessonType}/${item.id}`)
  }

  useEffect(() => {
      getDefault();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ param ])

  return (
    <>
    <ManageBar back={() => setVisible(true)} title="课程表" >
        <div className="app-tabs time-table">
          <div className="tool-wrapper">
            <div className="elem elem-left">
              <OrgPicker onChange={pickerChange}></OrgPicker>
            </div>
            <div className="elem elem-center">
              <TimeTool defaultDate={param.time} onChange={timeChange}></TimeTool>
            </div>
            {/* <div className="elem elem-right">
              <Button style={{height: '100%'}} type="primary" >
                创建新课
              </Button>
            </div> */}
          </div>
          <div className="table-wrapper">
              {
                data.list.map(item => (
                  <div onClick={() => handleClick(item)} key={item.id} className={`table-box-wrapper ${item.conferenceStatus === '1' ? 'active': item.conferenceStatus === '2' ? 'disabled': ''}`}>
                    <div className="table-box-container">
                    <div className="weight">{item.name}</div>
                    <div>{businessType.length > 0 && businessType.filter(t => t.value === item.typeCode)[0].text}</div>
                    <div className="red weight">{`${timeFormat(item.scheduledStartTime).format('HH:mm')}-${timeFormat(item.scheduledEndTime).format('HH:mm')}`}</div>
                    <div>{item.memberName}</div>
                    <div className="show-btn">{ item.conferenceStatus === '1' ? '已开始' : item.conferenceStatus === '2' ? '已结束': '未开始'}</div>
                    </div>
                  </div>
                ))
              }
              {
                data.list.length === 0 && 
                <EmptyContainer></EmptyContainer>
              }
          </div>
        </div>
      </ManageBar>
        <Modal
            className="layout-modal"
            transparent
            visible={visible}
            onClose={() => setVisible(false)}
            style={{ width: '20vw' }}
            title={'提示'}
            footer={[
                { text: '取消', onPress: () => setVisible(false)} ,
                { text: '确定', onPress: () => logout()}
            ]}
        >确认退出登陆么?</Modal>
      </>
  );
};

export default TimeTable;
